import { CheckIcon } from "@radix-ui/react-icons";
import React from "react";

export const ExternalDiagnosisSuccess = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <div className="max-w-md p-6 bg-white rounded-lg shadow-md dark:bg-gray-800">
        <div className="space-y-4 flex flex-col">
          <div className="flex items-center gap-x-2">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
              Tudo pronto!
            </h2>
            <CheckIcon className="size-8 text-green-700" />
          </div>
          <div className="flex flex-col gap-y-2">
            <p className="text-gray-600 dark:text-gray-400">
              As informações foram enviadas para o profissional responsável.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
